import * as React from 'react';

const TealiumEventPropertiesContext = /*#__PURE__*/ React.createContext({
    commonEventProperties: {},
    // Give the getCommonUserProperties function a fallback value,
    // which can be called whenever Tealium is not enabled (and this context is not included)
    getCommonUserProperties: ()=>Promise.resolve(undefined)
});
TealiumEventPropertiesContext.displayName = 'TealiumEventPropertiesContext';
const TealiumEventPropertiesProvider = (props)=>{
    const { commonEventProperties , getCommonUserProperties , children  } = props;
    return /*#__PURE__*/ React.createElement(TealiumEventPropertiesContext.Provider, {
        value: {
            commonEventProperties,
            getCommonUserProperties
        }
    }, children);
};
const useTealiumEventProperties = ()=>React.useContext(TealiumEventPropertiesContext)
;

export { TealiumEventPropertiesProvider, useTealiumEventProperties };
//# sourceMappingURL=event-properties-provider.js.map
